<app-header [showHamburger]="false"></app-header>

<div class="w-full h-screen flex justify-center items-center">
  @if (state() === State.Authenticating) {
    <app-pan-spinner size="lg"></app-pan-spinner>
  } @else {
    <div class="flex flex-col gap-4 w-full max-w-md">
      <app-pan-card header="Loss Prevention">
        <div role="status" class="flex items-center gap-2">
          <div class="w-full space-y-2">
            <div panRole [roles]="['self-service-investigator']">
              <app-page-select-location
                #locationSelect
                label="Select location"
                placeholder="Select location..."
                [selected]="location()"
                (selectedChange)="onLocationChange($event)"
              />
            </div>
            @switch (state()) {
              @case (State.CheckingExisting) {
                <div class="flex items-center gap-2" data-testid="checkingExistingAssignment">
                  <app-pan-spinner></app-pan-spinner>
                  <span>Checking for existing assignments...</span>
                </div>
              }
              @case (State.HasExisting) {
                <app-pan-inline-alert type="primary" data-testid="existingAssignmentAlert">
                  <div class="flex flex-col gap-2">
                    <div>You have an assignment that is in progress.</div>
                    <app-pan-button color="default" icon="arrow_forward" (click)="continueExistingAssignment()">Continue</app-pan-button>
                  </div>
                </app-pan-inline-alert>
              }
              @case (State.CheckingAvailable) {
                <div class="flex items-center gap-1">
                  <mat-icon class="text-danger">close</mat-icon>
                  <span>No existing assignment</span>
                </div>
                <div class="flex items-center gap-2" data-testid="checkingAvailableAssignment">
                  <app-pan-spinner></app-pan-spinner>
                  <span>Checking for available assignments...</span>
                </div>
              }
              @case (State.NoAvailable) {
                <app-pan-inline-alert type="info">
                  @if (locationId()) {
                    No assignments are available for this location, please select another location to review.
                  } @else {
                    No assignments are available to review as of this moment.
                  }
                </app-pan-inline-alert>
                <app-pan-button color="primary" icon="refresh" (click)="checkAssignment()"> Search again</app-pan-button>
              }
              @case (State.HasAvailable) {
                <div class="flex flex-col items-center gap-2">
                  <div class="flex items-center gap-1">
                    <mat-icon class="text-success">check</mat-icon>
                    <span>Available assignment</span>
                  </div>

                  <button panButton icon="arrow_forward" color="primary" (click)="nextAssignment()" data-testid="nextReview">
                    Next review
                  </button>

                  <div class="text-xs text-gray-500">(press only when you're ready to start)</div>
                </div>
              }
              @case (State.Starting) {
                <div class="flex items-center gap-2">
                  <app-pan-spinner></app-pan-spinner>
                  <span>Starting assignment...</span>
                </div>
              }
              @case (State.Error) {
                <app-pan-inline-alert type="danger">
                  {{ errorMessage() }}
                </app-pan-inline-alert>
              }
            }
          </div>
        </div>
      </app-pan-card>
    </div>
  }
</div>
